import { useEffect } from "react";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { useAdminData } from "./admin/AdminDataContext";
import { useLanguage } from "./LanguageContext";
import { localized } from "./admin/TranslationsPanel";
import { useTheme } from "./ThemeInjector";

export function HeroSection() {
  const { siteConfig } = useAdminData();
  const { lang } = useLanguage();
  const theme = useTheme();
  const { hero } = siteConfig;
  const l = (field: string) => localized(hero as any, field, lang);

  // Preload LCP image so it can be fetched early
  useEffect(() => {
    if (!hero?.image) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = hero.image;
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, [hero?.image]);

  return (
    <section className="relative w-full h-screen min-h-[600px]">
      <ImageWithFallback
        src={hero.image}
        alt="Matcha preparation"
        className="absolute inset-0 w-full h-full object-cover"
        width={1920}
        height={1080}
        fetchpriority="high"
      />
      <div className="absolute inset-0" style={{ background: `linear-gradient(to bottom, ${theme.fg}33, transparent, ${theme.bg}b3)` }} />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <h1
          className="text-white tracking-[0.2em] uppercase mb-4 drop-shadow-lg"
          style={{ fontFamily: theme.fontHeading, fontSize: "clamp(36px, 6vw, 72px)", fontWeight: 300 }}
        >
          {l("title")}
        </h1>
        <p
          className="text-white/90 tracking-[0.15em] mb-10 drop-shadow-md"
          style={{ fontFamily: theme.fontBody, fontSize: "clamp(14px, 2vw, 18px)", fontWeight: 300 }}
        >
          {l("subtitle")}
        </p>
        <a
          href="#collection"
          className="px-10 py-3 text-white tracking-[0.2em] uppercase transition-all duration-300"
          style={{
            fontFamily: theme.fontBody,
            fontSize: "13px",
            fontWeight: 400,
            backgroundColor: theme.accent,
            borderRadius: theme.btnRadius,
          }}
        >
          {l("cta_text")}
        </a>
      </div>
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-[1px] h-8 bg-white/50" />
      </div>
    </section>
  );
}